import projectService from 'services/ProjectService';
import ImportPresignedAssetUploadXHR from './ImportPresignedAssetUploadXHR';
import {
  STATUS_ANALYZING,
  UPLOAD_COMPLETED,
  UPLOAD_FAILED,
} from './constants';
/**
 * Lifecycle module for the ingestion asset upload,
 */
class ImportAssetUploadLifeCycle {
  init = ({
    adapterType,
    ingestionId,
    projectId,
    setPercentage,
    setUploadState,
    setIsLoading,
    onDismiss,
    getProjectIngestList,
    selectImportHistoryTab }) => {
    this.adapterType = adapterType;
    this.ingestionId = ingestionId;
    this.projectId = projectId;
    this.setPercentage = setPercentage;
    this.setUploadState = setUploadState;
    this.setIsLoading = setIsLoading;
    this.onDismiss = onDismiss;
    this.getProjectIngestList = getProjectIngestList;
    this.selectImportHistoryTab = selectImportHistoryTab;
  }

  upload = async ({ file, url }) => {
    const uploadFileXHR = new ImportPresignedAssetUploadXHR();
    const { onLoad, onError, onProgress } = this;
    uploadFileXHR.init({ url, onLoad, onError, onProgress });
    uploadFileXHR.send(file);
    this.uploadFileXHR = uploadFileXHR;
  };

  cancel = () => {
    this.uploadFileXHR.abort();
    this.delete();
  }

  delete = () => {
    projectService.deleteIngestion(this.ingestionId);
  };

  onProgress = (progressEvent) => {
    // total - represent the total file size.
    // loaded - represent the uploaded file.
    const { total, loaded } = progressEvent;
    const percent = Math.floor((loaded * 100) / total);
    this.setPercentage(percent);
  };

  onLoad = async () => {
    projectService.updateIngestion(this.ingestionId, this.projectId, STATUS_ANALYZING);
    projectService.startIngestion(this.ingestionId, this.adapterType);
    this.setPercentage(100);
    this.setUploadState(UPLOAD_COMPLETED);
    setTimeout(() => {
      this.setIsLoading(false);
      this.onDismiss();
      this.getProjectIngestList(this.projectId);
      this.selectImportHistoryTab();
    }, 3000);
  };

  onError = () => {
    this.setUploadState(UPLOAD_FAILED);
    this.setPercentage(0);
    this.delete();
  };
}

export default new ImportAssetUploadLifeCycle();
